export default __webpack_public_path__ + "static/media/732.52d06184.gif";